import { Col, Row, Form, Input, Select } from "antd";
import { useTranslation } from "react-i18next";
import { useState } from "react";

type prop = {
  supplier: any;
  setPhoneNumber: any;
  formatedCountryPhone: any;
};
function ContactInformation({ supplier, setPhoneNumber, formatedCountryPhone }: prop) {
  const [t] = useTranslation("common");

  const filterOption = (inputValue: string, option: any) => {
    // Extract the text content from the JSX label
    const label = option?.label?.props?.children;
    if (label) {
      const normalizedInput = inputValue.toLowerCase().trim();
      const normalizedLabel = label.toString().toLowerCase();
      return normalizedLabel.includes(normalizedInput);
    }
    return true;
  };

  const [, setPhoneNum] = useState("");
  const [, setErrorMessage] = useState("");

  const handlePhoneNumberChange = (e: any) => {
    const value = e.target.value;

    const regex = /^[0-9]*$/; // Updated regular expression
    if (regex.test(value)) {
      setPhoneNum(value);
      setErrorMessage("");
    } else {
      setErrorMessage("Please enter numbers only"); // Updated error message
    }
  };

  const handlePhoneNumberKeyPress = (e: any) => {
    const keyCode = e.keyCode || e.which;
    const keyValue = String.fromCharCode(keyCode);
    const regex = /[0-9.]|\./;

    if (!regex.test(keyValue)) {
      e.preventDefault();
    }

    if (keyValue === "." && e.target.value.indexOf(".") !== -1) {
      e.preventDefault();
    }
    if (keyValue === "." && e.target.selectionStart === 0) {
      e.preventDefault();
    }
  };

  const selectPhone = (
    <Form.Item name="phoneAreaCode" noStyle>
      <Select
        showSearch={true}
        filterOption={filterOption}
        style={{ width: 100, background: "white" }}
        options={formatedCountryPhone}
      />
    </Form.Item>
  );

  const selectMobile = (
    <Form.Item name="mobileAreaCode" noStyle>
      <Select
        showSearch={true}
        filterOption={filterOption}
        style={{ width: 100, background: "white" }}
        options={formatedCountryPhone}
      />
    </Form.Item>
  );

  const handlePhoneNumber = (event: any) => {
    setPhoneNumber(event);
    handlePhoneNumberChange(event);
  };

  return (
    <>
      <Row>
        <Col md={6}>
          <Form.Item
            name="email"
            label={`${t("email")}`}
            rules={[
              {
                type: "email",
              },
            ]}
          >
            <Input
              maxLength={50}
              autoComplete="off"
              placeholder={`${t("enter-text")}`}
              data-testid="email-input"
            />
          </Form.Item>

          <Form.Item label={`${t("primary-number")}`} name="phone">
            <Input
              addonBefore={selectPhone}
              maxLength={20}
              onChange={handlePhoneNumber}
              onKeyPress={handlePhoneNumberKeyPress}
              autoComplete="off"
              data-testid="phone-input"
              placeholder="000 000 000"
            />
          </Form.Item>

          <Form.Item label={`${t("secondary-number")}`} name="mobile">
            <Input
              addonBefore={selectMobile}
              maxLength={20}
              onChange={handlePhoneNumber}
              onKeyPress={handlePhoneNumberKeyPress}
              autoComplete="off"
              data-testid="phone-input"
              placeholder="000 000 000"
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
}

export default ContactInformation;
